import { PixelTester } from 'modules/PixelTester/PixelTester';
import { REPORT_PERMISSION } from 'modules/campaigns/config/reportPermissions';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { MODULE_NAME as TRACKING_MODULE } from 'modules/tracking/config/routes';
import { TEST_EVENTS_REPORT_ID } from './testEventsReportId';

export const testEventsTrackingReportConfig = {
    ignoreMissingEndpoint: true,
    component: PixelTester,
    id: TEST_EVENTS_REPORT_ID,
    label: 'Test Events',
    module: TRACKING_MODULE,
    columnsDef: [],
    permissions: [REPORT_PERMISSION.REALIZE_PIXEL_TESTER_SCREEN],
    accountConfigurations: { [FEATURE_FLAGS.PIXEL_TESTER_ENABLED]: 'true' },
};
